import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { PciI } from "interfaces/Pci";
import { Dropdown } from "react-bootstrap";
import { deletePci } from "services/pci";

interface Props {
  elemento: PciI;
  onClickEdit: (elemento: PciI) => void;
  onClickShowDetail: (elemento: PciI) => void;
  onClickCompare: (elemento: PciI) => void;
  refreshTable: () => void;
}

export const PCIRowActions = ({
  elemento,
  onClickEdit,
  onClickShowDetail,
  onClickCompare,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deletePci(id);
      showSuccessToast("¡El PCI fue eliminado con éxito!");
      refreshTable();
    } catch (error: any) {
      showErrorToast("Error eliminando el PCI: ", error.message);
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickShowDetail(elemento)}>
          Ver detalle
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickCompare(elemento)}>
          Comparar
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar PCI"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el PCI {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
